var map = {
	"./FPKG-10000-Theme/locale/TH.json": "131e",
	"./FPKG-10000-Theme/locale/VN.json": "f187",
	"./FPKG-10000-Theme/locale/en_US.json": "78c7",
	"./FPKG-10000-Theme/locale/zh_TW.json": "8059",
	"./FPKG-20000-Util/locale/zh_TW.json": "a630",
	"./FPKG-30000-Permission/locale/zh_TW.json": "0932",
	"./FPKG-40000-Account/locale/zh_TW.json": "9fa7",
	"./FPKG-60000-Organization/locale/zh_TW.json": "079a",
	"./FPKG-70000-Transaction/locale/zh_TW.json": "99ef",
	"./FPKG-90000-FedCustom/locale/zh_TW.json": "6a90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80f3";